import { PageHeadingClaim } from '@/components/layout/PageHeading';
import { ReactNode } from 'react';

type Props = {
  title?: ReactNode;
  description?: ReactNode;
  actions?: ReactNode;
  // Render the description on the SAME line as the title (baseline-aligned),
  // instead of stacked beneath it. Wraps on narrow screens.
  inline?: boolean;
};

export function PageHeader({ title, description, actions, inline }: Props) {
  return (
    <div className="flex items-start justify-between gap-4 mb-5">
      <div className={inline ? 'flex items-baseline gap-3 flex-wrap' : undefined}>
        {title && <><PageHeadingClaim /><h1 className="text-[1.375rem] font-semibold text-primary-text tracking-tight">{title}</h1></>}
        {description && <p className={`text-[0.8125rem] text-secondary ${inline ? '' : 'mt-1.5'}`}>{description}</p>}
      </div>
      {actions && <div className="flex items-center gap-2">{actions}</div>}
    </div>
  );
}
